import {
    Component,
    EventEmitter,
    Injector,
    Output,
    ViewChild,
  } from '@angular/core';
  import { ImpersonationService } from '@app/admin/users/impersonation.service';
  import { AppComponentBase } from '@shared/common/app-component-base';
  import { ModalDirective } from 'ngx-bootstrap/modal';

  @Component({
    selector: 'removeCustomFormConfirmModal',
    templateUrl: './remove-custom-form-confirm-modal.component.html',
    styleUrls: ['remove-custom-form-confirm-modal.component.less'],
  })
  export class RemoveCustomFormConfirmModalComponent extends AppComponentBase {
    @ViewChild('modal', { static: true }) modal: ModalDirective;

    form: any;

    @Output() removecustomform$: EventEmitter<any> = new EventEmitter<any>();

    constructor(
      injector: Injector
    ) {
      super(injector);
    }

    show(form: any): void {
      this.form = form;
      this.modal.show();
    }
    close(): void {
      this.modal.hide();
    }

    delete(): void {
      this.removecustomform$.emit(this.form);
      this.modal.hide();
    }
  }
